export const DAI_YIELD = 7.75;
export const TNA = 79.38;
export const LTV = 80;
export const THRESHOLD = 90;
export const MAX_BORROW = 5000000;
export const MAX_DAYS = 1000;
